import { appConstants } from "../constants/appConstants"

function setDrawerAppointments(appointments: any) {
  function loadData(data: any) {
    return { type: appConstants.DRAWER_APPOINTMENTS, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(appointments))
  }
}

function setDrawerComponent(componentData: any) {
  function loadData(data: any) {
    return { type: appConstants.COMPONENT_DATA, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(componentData))
  }
}

function refreshAppointments(booleanFlag: boolean) {
  function loadData(data: any) {
    return { type: appConstants.REFRESH_APPOINTMENTS, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(booleanFlag))
  }
}

function isConsultantsViewShown(booleanFlag: boolean) {
  function loadData(data: any) {
    return { type: appConstants.DISPLAY_CONSULTANTS_IN_DRAWER, data }
  }
  return (dispatch: any) => {
    dispatch(loadData(booleanFlag))
  }
}

function reset() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.RESET,
    })
  }
}

export const drawerAction = {
  setDrawerAppointments,
  refreshAppointments,
  setDrawerComponent,
  isConsultantsViewShown,
  reset
}

export default drawerAction
